export default __webpack_public_path__ + "static/convertFeatureHome-1197251b197fcf848c69f977a2d54911.svg";